export const baseColor = '#7F7DF3'
export const errorColor = '#F15179'
export const colorLight = '#5E5E5E'
export const colorDark = '#A6A5A5'
